<template>
<v-card>
  <v-list three-line class="py-0">
    <v-list-tile avatar @click="$emit('click',item)">
      <span :class="classTimeText" v-html="htmlTime" class="font-weight-black mr-3 px-2 headline" style="line-height:normal !important"></span>
      <v-list-tile-content>
        <v-list-tile-title class="brown--text">{{ item.name }}</v-list-tile-title>
        <v-list-tile-sub-title>{{ days }} <br> {{ item.timezone }}</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</v-card>
</template>

<script>
export default {
  name: 'ScheduleItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      alldays: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
      weekday: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'],
      weekend: ['sunday', 'saturday']
    }
  },
  computed: {
    days() {
      if (this.item.days.length == this.alldays.length && this.item.days.every(d => this.alldays.includes(d)))
        return this.$t('schedule.everyday');
      if (this.item.days.length == this.weekday.length && this.item.days.every(d => this.weekday.includes(d)))
        return this.$t('schedule.weekday');
      if (this.item.days.length == this.weekend.length && this.item.days.every(d => this.weekend.includes(d)))
        return this.$t('schedule.weekend');
      return this.item.days.map(d => this.$t(`schedule.${d}_abbr`)).join(', ');
    },
    htmlTime() {
      return this.item.time.replace(':', '<br>');
    },
    classTimeText() {
      return {
        'primary--text': this.item.enabled,
        'grey--text': !this.item.enabled,
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/schedule/ScheduleItem.vue